import React from 'react';
interface SectionCardProps {
  id: string;
  number: number;
  title: string;
  description?: string;
  children: React.ReactNode;
}
export function SectionCard({
  id,
  number,
  title,
  description,
  children
}: SectionCardProps) {
  return <section id={id} aria-labelledby={`${id}-heading`} className="scroll-mt-6 overflow-hidden rounded-lg border border-slate-200 bg-white shadow-sm" data-id="element-65" data-mp="1i249szu8uf5o">
      <header className="flex items-center gap-2.5 border-b border-slate-200 bg-slate-50 px-4 py-2.5" data-id="element-66" data-mp="pf0bfdpnoz2v">
        <span aria-hidden="true" className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-blue-600 text-[11px] font-semibold text-white" data-id="element-67" data-mp="ldepl2v59agj">
          {number}
        </span>
        <div className="min-w-0" data-id="element-68" data-mp="ubifebd5wte5">
          <h2 id={`${id}-heading`} className="text-sm font-semibold text-slate-900" data-id="element-69" data-mp="6nh9zbba5t2y">
            {title}
          </h2>
          {description && <p className="text-xs text-slate-500" data-id="element-70" data-mp="1ncr5emwgm9k">{description}</p>}
        </div>
      </header>
      <div className="space-y-5 px-4 py-4" data-id="element-71" data-mp="3soz21cx5pt6j">{children}</div>
    </section>;
}